import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const baseUrl = "https://taifurportfolioserver.onrender.com";
// const baseUrl = "http://localhost:4000";

const initialState = {
  isLoding: false,
  posts: [],
  responseStatus: "",
  responseMessage: "",
};

export const getPost = createAsyncThunk("post/getPost", async () => {
  try {
    const res = await axios.get(`${baseUrl}/api/posts`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
});

export const createPost = createAsyncThunk("post/createPost", async (post) => {
  try {
    const res = await axios.post(`${baseUrl}/api/posts`, post);
    return res.data;
  } catch (error) {
    console.log(error);
  }
});

export const updateViews = createAsyncThunk(
  "post/updateViews",
  async ({ viewsId, views }) => {
    try {
      const res = await axios.put(`${baseUrl}/api/posts`, { viewsId, views });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const updatePost = createAsyncThunk(
  "post/updatePost",
  async ({ title, image, body, id }) => {
    try {
      const res = await axios.patch(`${baseUrl}/api/posts/${id}`, {
        title,
        image,
        body,
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const deletePost = createAsyncThunk("post/deletePost", async (id) => {
  try {
    await axios.delete(`${baseUrl}/api/posts/${id}`);
    return id;
  } catch (error) {
    console.log(error);
  }
});

const postSlice = createSlice({
  name: "post",
  initialState: initialState,
  extraReducers: (build) => {
    build.addCase(createPost.pending, (state, action) => {
      state.isLoding = true;
      state.responseMessage = "pending";
    });
    build.addCase(createPost.fulfilled, (state, action) => {
      state.isLoding = false;
      state.posts.push(action.payload);
      state.responseStatus = "success";
      state.responseMessage = "Post created successfully";
    });
    build.addCase(createPost.rejected, (state, action) => {
      state.isLoding = false;
      state.responseMessage = action.payload;
      state.responseStatus = "Rejected";
    });
    build.addCase(getPost.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(getPost.fulfilled, (state, action) => {
      state.posts = action.payload;
      state.isLoding = false;
      state.responseStatus = "success";
      state.responseMessage = "posts get successfully";
    });
    build.addCase(getPost.rejected, (state, action) => {
      state.isLoding = false;
      state.posts = [];
      state.responseStatus = "rejected";
      state.responseMessage = action.error.message;
    });
    build.addCase(deletePost.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(deletePost.fulfilled, (state, action) => {
      state.posts = action.payload;
      state.isLoding = false;
      state.responseStatus = "success";
      state.responseMessage = "posts delete successfully";
    });
    build.addCase(deletePost.rejected, (state, action) => {
      state.isLoding = false;
      state.responseStatus = "rejected";
      state.responseMessage = action.error.message;
    });
    build.addCase(updatePost.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(updatePost.fulfilled, (state, action) => {
      const post = state.posts.filter((post) => post._id === action.payload.id);
      state.posts = post;
      state.isLoding = false;
      state.responseStatus = "success";
      state.responseMessage = "posts updated successfully";
    });
    build.addCase(updatePost.rejected, (state, action) => {
      state.isLoding = false;
      state.responseStatus = "rejected";
      state.responseMessage = action.error.message;
    });
    build.addCase(updateViews.pending, (state, action) => {
      state.isLoding = true;
      state.responseStatus = "pending";
    });
    build.addCase(updateViews.fulfilled, (state, action) => {
      state.isLoding = false;
      state.posts = action.payload;
      state.responseStatus = "success";
      state.responseMessage = "views updated successfully";
    });
    build.addCase(updateViews.rejected, (state, action) => {
      state.isLoding = false;
      state.responseStatus = "rejected";
      state.responseMessage = action.error.message;
    });
  },
});

export default postSlice.reducer;
